export function TripSummaryDefaultTextDisplay({ text }: { text: string }) {
  return <div className="text-xs font-light lg:text-sm">{text}</div>;
}
